// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.udrO2{display:flex;flex-direction:column;gap:8px;align-items:start}.J_h1C{display:flex;flex-direction:column;height:700px;max-height:min(700px,100vh - 128px)}.XpGlP{padding:20px;justify-content:flex-end;margin-top:auto}.p3ikO{overflow-y:auto;overflow-x:hidden;flex:1;min-height:0;padding:16px 24px;-webkit-overflow-scrolling:touch}.ILDXc{padding:0px;flex:1;min-height:0;display:flex;flex-direction:column;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"category": `udrO2`,
	"modalClassName": `J_h1C`,
	"footer": `XpGlP`,
	"contentClassName": `p3ikO`,
	"bodyClassName": `ILDXc`
};
export default ___CSS_LOADER_EXPORT___;
